import * as Yup from 'yup';
import { PHONE_WITH_EXTENSION_REGEX } from '../../shared/constants/regex';
import { CONTACT_METHOD_TYPE } from '../constants/addPersonFormConstants';

const addPlaceSchema = Yup.object({
  PlaceName: Yup.string().trim().nullable().required('Place Name is required'),
  ContactMethodType: Yup.string()
    .nullable()
    .when('ContactMethod', {
      is: (value) => Boolean(value),
      then: (schema) => schema.required('Contact Type is required'),
    }),
  Info: Yup.string()
    .nullable()
    .max(100, 'Info cannot exceed 100 characters')
    .when('ContactMethod', {
      is: CONTACT_METHOD_TYPE.PHONE,
      then: (schema) =>
        schema.matches(PHONE_WITH_EXTENSION_REGEX, {
          message: 'Invalid phone number',
          excludeEmptyString: true,
        }),
    })
    .when('ContactMethod', {
      is: CONTACT_METHOD_TYPE.EMAIL,
      then: (schema) => schema.email('Invalid email address'),
    }),
});

export default addPlaceSchema;
